import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Button from "../../Elements/Button/Button";
import { useAuthentication } from "../../../Hooks/useAuthentication";
import './header.css';

const Header = () => {
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("logindata");
    navigate("/");
    window.location.reload();
  };

  return (
    <nav id='header-quality' className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <div className='flex direction-row'>
            <span className='ms-2 header-title'>Empleados Quality Seal</span>
          </div>
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          {
            isAuthenticated &&
            <>
              <Link className='links' to="/calendario">Calendario</Link>
              <div className="d-flex">
                <Button
                  text="Cerrar sesión"
                  color="red"
                  fill
                  action={handleLogout}
                />
              </div>
            </>
          }
        </div>
      </div>
    </nav>
  )
}

export default Header